
import BaseActionButton from '@/components/common/BaseActionButton.vue'
import { openPickupConfirm } from '@/utils/pickupConfirm'

export default {
  name: 'OperatorOrderAction',
  components: { BaseActionButton },
  props: {
    order: { type: Object, required: true },
    mode: { type: String, default: 'detail' } // 'card' | 'detail'
  },
  data () {
    return {}
  },
  computed: {
    userId () { return this.$store.getters.currentUserId },
    isTakeover () { return !this.order.operator_id }, // 待接管的新单（operator_id IS NULL）：点开始验货即接管
    isMyProcessing () { return this.order.operator_id === this.userId && !this.order.assigned_courier_id },
    isInspected () { return this.order.inspection_status === 'completed' },
    isMyDelivery () { return this.order.assigned_courier_id === this.userId },
    isPickup () { return this.order.fulfillment_mode === 'pickup' },
    isDone () { return ['delivered', 'confirmed'].includes(this.order.status) },
    // pickup 单的 ownership：仅本人负责（operator_id=me）才有确认自提能力，消灭 dead action
    isOwner () { return this.order.operator_id === this.userId }
  },
  methods: {
    // 开始验货 = 接管(若未指派) + 导航到 operator 验货页（与 admin 同款 UI）。无"接单"按钮。
    async openInspect () {
      // 待接管订单：先原子接管（operator_id IS NULL → me，并发只成一个）
      if (!this.order.operator_id) {
        try { await this.axios.post('/operator-mobile/tasks/' + this.order.id + '/claim-processing') }
        catch (e) { return this.$toast.fail((e.response && e.response.status === 409) ? '订单已被他人接管，请刷新' : '接管失败') }
        this.order.operator_id = this.userId
        this.$emit('refresh')
      }
      // 进入 operator 验货页（fetchData 自动开始验货 + 写 inspection_start 事件）
      this.$router.push('/operator/order/' + this.order.id + '/inspection')
    },
    // 三选择
    // 指派配送员 → 复用 admin 同款指派页（/operator/order/:id/assign），仅 API 换 operator-mobile
    openAssign () {
      this.$router.push('/operator/order/' + this.order.id + '/assign')
    },
    // 配送开始（复用 /mobile-delivery）；完成送达→送达抽屉由父级复用 courier 组件
    async startDeliver () {
      try { await this.axios.post('/mobile-delivery/orders/' + this.order.id + '/start'); this.$toast.success('已开始配送'); this.$emit('refresh') }
      catch (e) { this.$toast.fail((e.response && e.response.data && e.response.data.message) || '操作失败') }
    },
    // 确认已自提（自提单完成动作：等价完成送达，直达已完成，不等用户确认）
    // 弹窗展示**本单**自提码供店员与顾客核对（2026-09-24 取代 window.prompt；请求与失败留在弹窗内）
    confirmPickup () {
      openPickupConfirm(this, this.order, () => { this.$emit('refresh') })
    }
  }
}
